module.exports = __webpack_public_path__ + "img/trade-dsm-splash.c2064fe0.png";